import type * as React from 'react';

export function PublisherAppsMethodCard({
  icon,
  label,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className="border-border hover:border-primary hover:bg-muted flex min-h-44 flex-col items-center justify-center gap-4 rounded-xl border p-6 text-center font-semibold"
      onClick={onClick}
    >
      <span className="text-primary">{icon}</span>
      {label}
    </button>
  );
}
